'use client';

import { Suspense } from "react";
import { useName } from "../hooks/useName";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";

export function LinkedInFooterLink(): React.ReactNode {
	return <Suspense fallback={null}>
		<LinkedInFooterLinkAfterSuspense />
	</Suspense>;
}

function LinkedInFooterLinkAfterSuspense(): React.ReactNode {
	const realName = useName();
	if (!realName.isReal) return null;

	// A little bit of obfuscation make it harder
	// to find my LinkedIn profile by just scraping the source code.

	// get name JSON mod 2 to determine if there should be a dash between the first and last name
	const jsonCharSum = Array.from(JSON.stringify(realName)).reduce((sum, char) => sum + char.charCodeAt(0), 0);
	const hasDash = (jsonCharSum % 2) === 0;

	// get last+salt mod 2 to determine if the last name should go before the first name
	const firstLastCharSum = Array.from(realName.lastName + process.env.NEXT_PUBLIC_REAL_NAME_HASH_SALT).reduce((sum, char) => sum + char.charCodeAt(0), 0);
	const isLastNameFirst = (firstLastCharSum % 2) === 0;

	const firstPart = isLastNameFirst ? realName.lastName : realName.firstName;
	const dash = hasDash ? '-' : '';
	const secondPart = isLastNameFirst ? realName.firstName : realName.lastName;

	return <a href={`https://linkedin.com/in/${firstPart}${dash}${secondPart}`.toLowerCase()} target="_blank" rel="noopener noreferrer" title="LinkedIn">
		<FontAwesomeIcon icon={faLinkedin} /> LinkedIn
	</a>;
}
